module.exports = __webpack_public_path__ + "static/media/vanLight.e383ee26.svg";